// components/ImageUploader.jsx
//
// A drop-in "Upload Image" button + preview, used anywhere the admin
// panel currently asks for an image URL (product icon, site logo, QR
// code). Instead of pasting a Cloudinary URL manually, admin picks a
// file from their device, it uploads directly to Cloudinary from the
// browser, and the returned URL is handed back via onUploaded().
//
// Uses an UNSIGNED upload preset - this means the upload can happen
// straight from the browser without exposing your Cloudinary API secret
// (which should NEVER be in frontend code). You set this up once in your
// Cloudinary dashboard:
//
//   1. Go to Settings -> Upload -> Upload presets -> Add upload preset
//   2. Set "Signing Mode" to "Unsigned"
//   3. (Optional but recommended) Set a folder name like "nfxseller" so
//      uploads are organized
//   4. Copy the preset name into UPLOAD_PRESET below
//   5. Copy your Cloud Name (shown on your Cloudinary dashboard home
//      page) into CLOUD_NAME below

import React, { useState } from 'react';

const CLOUD_NAME = 'dvjfsqfq';       // <-- replace with your Cloudinary cloud name
const UPLOAD_PRESET = 'banner'; // <-- replace with your unsigned upload preset name

function ImageUploader({ currentUrl, onUploaded, label = 'Image' }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError('');
    setUploading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);

    try {
      const res = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        { method: 'POST', body: formData }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error?.message || 'Upload failed');
      }

      // secure_url is the HTTPS link Cloudinary gives back - this is
      // exactly what gets saved into MongoDB (as product.icon, or
      // settings.siteLogo / settings.qrCodeImage)
      onUploaded(data.secure_url);
    } catch (err) {
      setError(err.message || 'Upload failed. Please try again.');
    } finally {
      setUploading(false);
      e.target.value = ''; // reset so the same file can be re-selected if needed
    }
  };

  return (
    <div style={{ marginBottom: '12px' }}>
      <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}>{label}</label>

      {currentUrl && (
        <img
          src={currentUrl}
          alt="Current"
          style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '6px', marginBottom: '6px', display: 'block' }}
        />
      )}

      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={uploading}
      />

      {uploading && <p style={{ fontSize: '12px', color: '#888', margin: '4px 0 0' }}>Uploading...</p>}
      {error && <p style={{ fontSize: '12px', color: 'red', margin: '4px 0 0' }}>{error}</p>}
    </div>
  );
}

export default ImageUploader;
